var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPopcorn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m414.764 130.667c3.183-13.939.971-29.672-6.63-42.836-8.085-13.997-21.734-24.176-36.402-27.895-3.718-14.676-13.9-28.326-27.902-36.406-13.998-8.078-30.904-10.071-45.466-5.957-10.554-10.844-26.195-17.573-42.364-17.573-16.161 0-31.801 6.729-42.358 17.572-14.561-4.114-31.47-2.124-45.472 5.958-14.002 8.08-24.184 21.731-27.902 36.406-14.669 3.719-28.316 13.899-36.393 27.892-7.606 13.161-9.822 28.897-6.639 42.838h317.528zm-201.504-59.874c23.565-23.565 61.911-23.567 85.48 0 5.857 5.858 5.858 15.355 0 21.213-5.857 5.857-15.355 5.858-21.213 0-11.873-11.872-31.186-11.869-43.055 0-5.858 5.859-15.357 5.857-21.213 0-5.858-5.858-5.858-15.355.001-21.213z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m223.568 512h64.864l17.566-351.333h-99.996z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m95.333 160.667c-4.366 0-8.517 1.903-11.366 5.211-2.85 3.309-4.115 7.695-3.468 12.014l48.2 321.333c1.102 7.343 7.409 12.775 14.834 12.775h49.998l-17.566-351.333z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m428.033 165.878c-2.85-3.309-7-5.211-11.366-5.211h-80.632l-17.566 351.333h49.998c7.425 0 13.732-5.432 14.834-12.775l48.2-321.333c.647-4.319-.618-8.705-3.468-12.014z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopcorn);
export default __webpack_public_path__ + "static/media/popcorn.4bf1b1d1.svg";
export { ForwardRef as ReactComponent };